/* eslint-disable */
import React, { Component } from 'react';
import Select from 'react-select';
import styled from 'styled-components';

import ErrorMessage from './ErrorMessage';

export default class LabelledTextInput extends Component {
  constructor(props) {
    super(props);

  }

  render() {
    const {
      errorMessage,
    } = this.props;

    let display = !!this.props.value ? 'block' : 'none';
    let marginTop = !!this.props.value ? '20px' : '10px';
    if (this.props.isMulti) {
      // display = this.props.value.length > 0 ? 'block' : 'none';
      // marginTop = this.props.value.length > 0 ? '20px' : '10px';
    }
    display = 'block';
    marginTop = '20px';

    return (
      <Container
        style={this.props.style || {}}
        // onClick={this.focus}
        color={errorMessage ? '#ff5c6c' : '#E2E5EF'}
        borderColor={errorMessage ? '#ff5c6c' : '#E2E5EF'}
      >
        <label htmlFor={this.props.name} style={{ display }}>{this.props.placeHolder}</label>
        <Select
          // placeholder={this.props.placeHolder}
          placeholder={''}
          styles={{
            valueContainer: styles => ({
              // height: 20,
              width: 280,
              display: 'flex',
              flexWrap: 'wrap',
            }),
            control: styles => ({
              ...styles,
              border: 0,
              boxShadow: 0,
              '&:hover': {
                border: 0,
              },
              padding: 0,
              margin: 0,
              marginTop: 20,
              backgroundColor: 'none',
              fontSize: 22,
              fontFamily: "'Karla', sans-serif",
            }),
            input: styles => ({
              ...styles,
              fontSize: 22,
              fontFamily: "'Karla', sans-serif",
              backgroundColor: 'blue',
            }),
            menu: styles => ({
              ...styles,
              whiteSpace: 'nowrap',
              width: 'auto',
              fontSize: 22,
              fontFamily: "'Karla', sans-serif",
            }),
            multiValue: styles => ({
              ...styles,
              height: 25,
              marginRight: 5,
              marginBottom: 5,
              // marginRight: 2,
            }),
            singleValue: styles => ({
              ...styles,
              height: 25,
              margin: 0,
            }),
          }}
          value={this.props.value}
          onChange={this.props.onChange}
          options={this.props.options}
          isMulti={this.props.isMulti}
          components={{
            // DropdownIndicator: () => null,
            ClearIndicator: () => null,
            IndicatorSeparator: () => null,
            // IndicatorsContainer: () => null,
            // MultiValueRemove: () => null,
          }}
          isSearchable={false}
        />
        {/* <select
          value={this.props.value}
          onChange={this.props.onChange}
          style={{
            marginTop: 20,
            border: 'none',
            marginLeft: -8,
            backgroundColor: 'white',
            width: '105%',
            fontSize: 22,
          }}
          multiple={this.props.multiple}
        >
          {this.props.options.map(o => <option>{o}</option>)}
        </select> */}
        {errorMessage ? (<ErrorMessage message={errorMessage} style={{ marginTop: 0 }} />) : null}
      </Container>
    );
  }
}

const Container = styled.div`
  // height: 50px;
  border: ${props => `2px solid ${props.borderColor};`}
  border-radius: 0.25em;
  padding: 0.7em 1em;
  margin-bottom: 20px;

  input {
    font-size: 22px;
    width: 425px;
    position: absolute;
    background: transparent;
    border: 0px;
    padding: 0px;
    font-family: 'Karla', sans-serif;
    color: ${props => `${props.color};`}

    &::placeholder {
      opacity: 1;
      color: #a1aeb7;
    }
    &:focus {
      outline: none;
    }
  }

  label {
    position: absolute;
    color: #9da1bb;
    font-size: 15px;
    margin-top: 2px;
    font-family: 'Karla', sans-serif;
  }
`;



// WEBPACK FOOTER //
// ./client/shared/LabelledSelect.js